import { useState } from 'react';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Tooltip,
} from '@mui/material';
import { Edit, Close } from '@mui/icons-material';
import { useUser } from '../../../contexts/UserContext';
import { TEAM_MEMBERS } from '../../../config/team';

const UserSelector = () => {
  const { selectedUser, setSelectedUser, customSignoff, setCustomSignoff } = useUser();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [signoffText, setSignoffText] = useState(customSignoff);

  const handleUserChange = (event: SelectChangeEvent<number>) => {
    const userId = event.target.value as number;
    const user = TEAM_MEMBERS.find(member => member.id === userId);
    if (user) {
      setSelectedUser(user);
    }
  };

  const handleOpenDialog = () => {
    setSignoffText(customSignoff);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleSaveSignoff = () => {
    setCustomSignoff(signoffText);
    setIsDialogOpen(false);
  };

  return (
    <>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        whiteSpace: 'nowrap'
      }}>
        <Typography variant="body2" color="text.secondary" fontWeight={500}>
          User:
        </Typography>
        <FormControl size="small" sx={{ minWidth: 190 }}>
          <Select
            value={selectedUser?.id ?? ""}
            onChange={handleUserChange}
            displayEmpty
            variant="outlined"
            sx={{ fontSize: '0.875rem', fontWeight: 500 }}
          >
            {TEAM_MEMBERS.map((member) => (
              <MenuItem key={member.id} value={member.id}>
                {member.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Tooltip title="Edit email signoff">
          <IconButton
            onClick={handleOpenDialog}
            aria-label="Edit email signoff"
            sx={{
              width: 40,
              height: 40,
              border: 1,
              borderColor: 'divider',
              bgcolor: 'background.paper',
              '&:hover': { bgcolor: 'action.hover' },
            }}
          >
            <Edit fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Custom Signoff Dialog */}
      <Dialog open={isDialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Custom Email Signoff</Typography>
          <IconButton size="small" onClick={handleCloseDialog}>
            <Close fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Customize your email signature. Use the format: Name, company address, contact details.
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={signoffText}
              onChange={(e) => setSignoffText(e.target.value)}
              placeholder={`${selectedUser?.name ?? ''}\n\nDBR SYSTEMS PTE LTD\n1 ROCHOR CANAL ROAD\n#02-30 SIM LIM SQUARE\nSINGAPORE 188504\nTEL: 63347055 FAX: 63365930${selectedUser?.mobile ? `\nHP: ${selectedUser.mobile}` : ''}`}
              variant="outlined"
              size="small"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSaveSignoff} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserSelector; 